export default __webpack_public_path__ + "static/media/caseSlide8.b090377e.png";